import { Container } from "@mui/material";

import {
  Text,
  Button,
  TextInput,
  CopyButton,
  Tooltip,
  Table,
  Modal,
  Loader,
  Divider,
  Pagination,
  Select,
  SelectProps,
  ActionIcon,
} from "@mantine/core";

import DatagridDisplay from "../../Components/DatagridDisplay";
import dayjs from "dayjs";
import { GridRenderCellParams, GridRowParams } from "@mui/x-data-grid";

import "./styles.scss";
import { PerformRequest, usePerformRequest } from "../../Lib/usePerformRequest";
import { NonPaginatedResponse, PaginatedResponse } from "../../Lib/Responses";
import {
  PaginationProps,
  PlanProps,
  UserProfileProps,
  UserSubscriptionProps,
} from "../../Lib/Types";
import { Endpoints } from "../../Lib/Endpoints";
import { BrandImages, Colors, ServiceList } from "../../Lib/Data";
import { useForm } from "@mantine/form";
import { useEffect, useState } from "react";
import MegaLoader from "../../Components/MegaLoader";
import { useClickOutside, useDisclosure } from "@mantine/hooks";
import {
  convertPhoneToWhatsapp,
  DefaultErrorNotification,
  DefaultSuccessNotification,
  DefaultWarningNotification,
  generateRandomString,
  getPaginationTotal,
} from "../../Lib/Methods";
import DisplayAlert from "../../Components/DisplayAlert";
import { IconBrandWhatsapp, IconReload } from "@tabler/icons-react";
import { Link } from "react-router-dom";
const Subscriptions: React.FC = () => {
  const filterForm = useForm({
    initialValues: {
      service: "",
      userID: "",
      status: "",
      sortByMostRecent: "yes",
    },
    validate: {
      status: (value) => (value && value.length >= 0 ? null : true),
    },
  });
  const spotifyLinkForm = useForm({
    initialValues: {
      link: "",
    },
    validate: {
      link: (value) =>
        value && value.length > 0 ? null : "Please enter a link!",
    },
  });
  const duolingoLinkForm = useForm({
    initialValues: {
      link: "",
    },
    validate: {
      link: (value) =>
        value && value.length > 0 ? null : "Please enter a link!",
    },
  });
  const [pagination, setPagination] = useState<PaginationProps>({
    page: 1,
    limit: 10,
  });
  const {
    data: subscriptions,
    reloadData: reloadSubscriptions,
    isLoading: isLoadingSubscriptions,
  } = usePerformRequest<PaginatedResponse<UserSubscriptionProps[]>>({
    method: "POST",
    route: Endpoints.GetUsersSubscriptions(pagination.page, pagination.limit),
    body: {
      service: filterForm.values.service,
      userID: filterForm.values.userID,
      isExpired:
        filterForm.values.status.length > 0
          ? filterForm.values.status === "expired"
          : "",
      sortByMostRecent:
        filterForm.values.sortByMostRecent.length > 0
          ? filterForm.values.sortByMostRecent === "yes"
          : "",
    },
  });

  useEffect(() => {
    reloadSubscriptions();
  }, [filterForm.values]);
  const [
    isSubscriptionModalOpened,
    { open: OpenSubscriptionModal, close: CloseSubscriptionModal },
  ] = useDisclosure(false);

  const [isLoadingPlan, setLoadingPlan] = useState<boolean>(false);
  const [currentUser, setCurrentUser] = useState<UserProfileProps>();
  const [currentSubscription, setCurrentSubscription] =
    useState<UserSubscriptionProps>();
  const [currentSubscriptionPlan, setCurrentSubscriptionPlan] =
    useState<PlanProps>();

  useEffect(() => {
    const GetSubscriptionPlan = async () => {
      setLoadingPlan(true);
      const r = await PerformRequest<NonPaginatedResponse<PlanProps>>({
        method: "GET",
        route: Endpoints.GetSinglePlan(currentSubscription?.planID as string),

        callback: () => {
          setLoadingPlan(false);
        },
      });
      setLoadingPlan(false);
      if (r) {
        if (r.status === 200) {
          if (r.data.data) {
            setCurrentSubscriptionPlan(r.data.data);
          } else {
            DefaultWarningNotification("Plan was not found!");
          }
        } else {
          DefaultErrorNotification("Could not get plan!");
        }
      }
    };
    const GetUserProfile = async () => {
      if (currentSubscription && currentSubscription.userID) {
        const r = await PerformRequest<NonPaginatedResponse<UserProfileProps>>({
          method: "GET",
          route: Endpoints.GetUserProfile(currentSubscription.userID),
        });
        if (r) {
          if (r.status === 404) {
            DefaultErrorNotification("User does not exist!");
          }
          if (r.status === 200) {
            setCurrentUser(r.data.data);
          }
        }
      }
    };
    if (currentSubscription && currentSubscription.userID) {
      GetUserProfile();
      GetSubscriptionPlan();
    }
  }, [currentSubscription]);

  const [isUpdatingSpotifyLink, setUpdatingSpotifyLink] =
    useState<boolean>(false);
  const UpdateSpotifyLink = async (subscriptionID: string) => {
    const { hasErrors } = spotifyLinkForm.validate();
    if (!hasErrors) {
      const { link } = spotifyLinkForm.values;

      setUpdatingSpotifyLink(true);
      const r = await PerformRequest({
        method: "POST",
        route: Endpoints.UpdateSpotifyInviteLink(subscriptionID),
        data: {
          spotifyLink: link,
        },
        callback: () => {
          setUpdatingSpotifyLink(false);
        },
      });
      setUpdatingSpotifyLink(false);

      if (r) {
        if (r.status === 200) {
          reloadSubscriptions();
          DefaultSuccessNotification("Link has been updated!");
        }
      } else {
        DefaultErrorNotification("Could not update link");
      }
    }
  };

  const [isUpdatingDuolingoLink, setUpdatingDuolingoLink] =
    useState<boolean>(false);
  const UpdateDuolingoLink = async (subscriptionID: string) => {
    const { hasErrors } = duolingoLinkForm.validate();
    if (!hasErrors) {
      const { link } = duolingoLinkForm.values;

      setUpdatingDuolingoLink(true);
      const r = await PerformRequest({
        method: "POST",
        route: Endpoints.UpdateDuolingoInviteLink(subscriptionID),
        data: {
          duolingoLink: link,
        },
        callback: () => {
          setUpdatingDuolingoLink(false);
        },
      });
      setUpdatingDuolingoLink(false);

      if (r) {
        if (r.status === 200) {
          reloadSubscriptions();
          DefaultSuccessNotification("Link has been updated!");
        }
      } else {
        DefaultErrorNotification("Could not update link");
      }
    }
  };

  const selectProps: SelectProps = {
    allowDeselect: false,
  };
  return (
    <Container maxWidth="xl">
      <div className="subscriptions-container">
        <div className="component-header">
          <div className="flex-row align-center justify-between width-100">
            <Text className="label">Subscriptions</Text>
            <Button
              loading={isLoadingSubscriptions}
              onClick={reloadSubscriptions}
              leftSection={<IconReload size={16} />}
            >
              Reload
            </Button>
          </div>
          <div className="flex-row">
            <Select
              w={190}
              {...selectProps}
              {...filterForm.getInputProps("service")}
              label="Service"
              mr={10}
              data={[
                { value: "", label: "All" },
                ...ServiceList.map((service) => {
                  return {
                    value: service,
                    label: service,
                  };
                }),
              ]}
            />
            <Select
              w={190}
              {...selectProps}
              {...filterForm.getInputProps("status")}
              label="Status"
              mr={10}
              data={[
                { value: "", label: "All" },
                { value: "active", label: "Active" },
                { value: "expired", label: "Expired" },
              ]}
            />
            <Select
              w={290}
              {...selectProps}
              {...filterForm.getInputProps("sortByMostRecent")}
              label="Sort by most recent"
              mr={10}
              data={[
                { value: "yes", label: "Yes" },
                { value: "no", label: "No" },
              ]}
            />
          </div>
          <br />
          {currentSubscription && (
            <Modal
              opened={isSubscriptionModalOpened}
              onClose={() => {
                CloseSubscriptionModal();
                spotifyLinkForm.reset();
                setCurrentSubscription(undefined);
                setCurrentSubscriptionPlan(undefined);
                setCurrentUser(undefined);
              }}
              title="Subscription Details"
              centered
              size="lg"
            >
              <Table variant="vertical" layout="fixed" withTableBorder>
                <Table.Thead>
                  <Table.Tr key={generateRandomString(12)}>
                    <Table.Th w={200}>Transaction ID</Table.Th>
                    <Table.Td>
                      <CopyButton value={currentSubscription.transactionID}>
                        {({ copied, copy }) => (
                          <Tooltip
                            label={copied ? "Copied!" : "Copy to clipboard"}
                          >
                            <div
                              className="pointer flex-row align-center"
                              onClick={copy}
                              style={{
                                color: copied
                                  ? Colors.GreenPrimary
                                  : Colors.BluePrimary,
                                height: "100%",
                              }}
                            >
                              {currentSubscription.transactionID}
                            </div>
                          </Tooltip>
                        )}
                      </CopyButton>
                    </Table.Td>
                  </Table.Tr>
                  <Table.Tr key={generateRandomString(12)}>
                    <Table.Th>First Subscription Date</Table.Th>
                    <Table.Td>
                      {dayjs(currentSubscription.createdAt).format(
                        "DD MMM YYYY - hh:mmA"
                      )}
                    </Table.Td>
                  </Table.Tr>
                  <Table.Tr key={generateRandomString(12)}>
                    <Table.Th>Last Subscription Date</Table.Th>
                    <Table.Td>
                      {dayjs(currentSubscription.lastSubscriptionDate).format(
                        "DD MMM YYYY - hh:mmA"
                      )}
                    </Table.Td>
                  </Table.Tr>
                  <Table.Tr key={generateRandomString(12)}>
                    <Table.Th>Service</Table.Th>
                    <Table.Td>
                      <div className="flex-row align-center temp-service-images">
                        <img
                          src={BrandImages.retrieveImage(
                            currentSubscription.service
                          )}
                          alt=""
                          className="image"
                        />
                      </div>
                    </Table.Td>
                  </Table.Tr>
                  <Table.Tr key={generateRandomString(12)}>
                    <Table.Th>Expiry</Table.Th>
                    <Table.Td
                      c={
                        dayjs().isAfter(dayjs(currentSubscription.expiresAt))
                          ? Colors.RedPrimary
                          : Colors.GreenSecondary
                      }
                    >
                      {dayjs(currentSubscription.expiresAt).format(
                        "DD MMM YYYY - hh:mmA"
                      )}
                    </Table.Td>
                  </Table.Tr>
                </Table.Thead>
              </Table>

              <Divider w="100%" mt={15} mb={10} />
              <Text fw={500} mb={10} c={Colors.GreenSecondary}>
                User Information
              </Text>
              <Table variant="vertical" layout="fixed" withTableBorder>
                <Table.Thead>
                  <Table.Tr key={generateRandomString(12)}>
                    <Table.Th w={200}>Name</Table.Th>
                    <Table.Td>
                      {currentUser?.name ?? <Loader size={15} />}
                    </Table.Td>
                  </Table.Tr>
                  <Table.Tr key={generateRandomString(12)}>
                    <Table.Th>Email</Table.Th>
                    <Table.Td>
                      {currentUser?.email ? (
                        <CopyButton value={currentUser.email}>
                          {({ copied, copy }) => (
                            <Tooltip
                              label={copied ? "Copied!" : "Copy to clipboard"}
                            >
                              <Text
                                fz={14}
                                c={
                                  copied
                                    ? Colors.GreenPrimary
                                    : Colors.BluePrimary
                                }
                                onClick={copy}
                              >
                                {currentUser.email}
                              </Text>
                            </Tooltip>
                          )}
                        </CopyButton>
                      ) : (
                        <Loader size={15} />
                      )}
                    </Table.Td>
                  </Table.Tr>
                  <Table.Tr key={generateRandomString(12)}>
                    <Table.Th w={200}>Phone</Table.Th>
                    <Table.Td>
                      {currentUser?.phone ? (
                        <div className="flex-row align-center">
                          <CopyButton value={currentUser.phone}>
                            {({ copied, copy }) => (
                              <Tooltip
                                label={copied ? "Copied!" : "Copy to clipboard"}
                              >
                                <div
                                  className="pointer flex-row align-center"
                                  onClick={copy}
                                  style={{
                                    color: copied
                                      ? Colors.GreenPrimary
                                      : Colors.BluePrimary,
                                    height: "100%",
                                  }}
                                >
                                  {currentUser.phone}
                                </div>
                              </Tooltip>
                            )}
                          </CopyButton>
                          <ActionIcon
                            variant="subtle"
                            size="md"
                            ml={5}
                            color={Colors.GreenPrimary}
                            onClick={() => {
                              window.open(
                                `https://wa.me/${convertPhoneToWhatsapp(
                                  currentUser.phone
                                )}`,
                                "_blank"
                              );
                            }}
                          >
                            <IconBrandWhatsapp size={18} />
                          </ActionIcon>
                        </div>
                      ) : (
                        <Loader size={15} />
                      )}
                    </Table.Td>
                  </Table.Tr>
                </Table.Thead>
              </Table>
              <Divider w="100%" mt={15} mb={10} />
              <Text fw={500} mb={10} c={Colors.GreenSecondary}>
                Assigned Plan
              </Text>
              {currentSubscriptionPlan &&
              currentSubscriptionPlan &&
              currentSubscriptionPlan.id ? (
                <>
                  <Table variant="vertical" layout="fixed" withTableBorder>
                    <Table.Thead>
                      <Table.Tr key={generateRandomString(12)}>
                        <Table.Th w={200}>Plan ID</Table.Th>
                        <Table.Td>{currentSubscriptionPlan.id}</Table.Td>
                      </Table.Tr>
                      <Table.Tr key={generateRandomString(12)}>
                        <Table.Th w={200}>Available Slots</Table.Th>
                        <Table.Td>
                          {currentSubscriptionPlan.slots -
                            currentSubscriptionPlan?.users?.length}
                        </Table.Td>
                      </Table.Tr>
                      <Table.Tr key={generateRandomString(12)}>
                        <Table.Th>Expiration Date</Table.Th>
                        <Table.Td
                          c={
                            dayjs().isBefore(
                              currentSubscriptionPlan.expirationDate
                            )
                              ? Colors.GreenPrimary
                              : Colors.RedPrimary
                          }
                        >
                          {dayjs(
                            currentSubscriptionPlan?.expirationDate
                          ).format("DD MMM YYYY - hh:mmA")}
                        </Table.Td>
                      </Table.Tr>
                      <Table.Tr key={generateRandomString(12)}>
                        <Table.Th>Service</Table.Th>
                        <Table.Td>
                          <div className="flex-row align-center temp-service-images">
                            <img
                              src={BrandImages.retrieveImage(
                                currentSubscriptionPlan.service
                              )}
                              alt=""
                              className="image"
                            />
                          </div>
                        </Table.Td>
                      </Table.Tr>
                    </Table.Thead>
                  </Table>
                  {currentSubscriptionPlan.service === "Spotify Premium" && (
                    <div className="flex-col">
                      <TextInput
                        w="100%"
                        label="Invite link"
                        placeholder="Paste Spotify invite link"
                        mt={20}
                        {...spotifyLinkForm.getInputProps("link")}
                      />
                      <Button
                        radius="50px"
                        mt={10}
                        w={150}
                        c={Colors.White}
                        color={Colors.GreenPrimary}
                        onClick={() => {
                          UpdateSpotifyLink(currentSubscription.id);
                        }}
                        loading={isUpdatingSpotifyLink}
                      >
                        Update Link
                      </Button>
                    </div>
                  )}
                  {currentSubscriptionPlan.service === "Duolingo Super" && (
                    <div className="flex-col">
                      <TextInput
                        w="100%"
                        label="Invite link"
                        placeholder="Paste Duolingo invite link"
                        mt={20}
                        {...duolingoLinkForm.getInputProps("link")}
                      />
                      <Button
                        radius="50px"
                        mt={10}
                        w={150}
                        c={Colors.White}
                        color={Colors.GreenPrimary}
                        onClick={() => {
                          UpdateDuolingoLink(currentSubscription.id);
                        }}
                        loading={isUpdatingDuolingoLink}
                      >
                        Update Link
                      </Button>
                    </div>
                  )}
                  <Divider w="100%" mt={20} mb={10} />
                  <div className="flex-row align-center">
                    <Link
                      to={`/dashboard/subscription/${currentSubscription.id}`}
                    >
                      <Button w={120} color={Colors.BluePrimary}>
                        Full Details
                      </Button>
                    </Link>
                    &nbsp; &nbsp;
                    <Link to={`/dashboard/plan/${currentSubscriptionPlan.id}`}>
                      <Button w={120} color={Colors.BluePrimary}>
                        View Plan
                      </Button>
                    </Link>
                    &nbsp; &nbsp;
                    <Link to={`/dashboard/user/${currentUser?.id}`}>
                      <Button w={120} color={Colors.BluePrimary}>
                        View User
                      </Button>
                    </Link>
                  </div>
                </>
              ) : (
                <>
                  {isLoadingPlan ? (
                    <div className="flex-row align-center justify-center width-100">
                      <Loader my={20} size={34} />
                    </div>
                  ) : (
                    <DisplayAlert
                      title="No Plan Found"
                      children={
                        <Text>
                          For some reason, this subscription does not belong to
                          any plan!
                        </Text>
                      }
                    />
                  )}
                </>
              )}
            </Modal>
          )}
          {subscriptions && subscriptions.data && (
            <>
              <DatagridDisplay
                rows={subscriptions?.data as any}
                isLoading={isLoadingSubscriptions}
                onRowClick={(params: GridRowParams<UserSubscriptionProps>) => {
                  OpenSubscriptionModal();
                  setCurrentSubscription(params.row);
                  spotifyLinkForm.setFieldValue(
                    "link",
                    params.row?.spotifyLink ?? ""
                  );
                  duolingoLinkForm.setFieldValue(
                    "link",
                    params.row?.duolingoLink ?? ""
                  );
                }}
                columns={[
                  {
                    field: "createdAt",
                    width: 220,

                    headerName: "Initial Subscription Date",
                    renderCell: (
                      params: GridRenderCellParams<UserSubscriptionProps>
                    ) => {
                      return (
                        <div>
                          {dayjs(params.row.createdAt).format("DD MMM YYYY")}
                          &nbsp;at&nbsp;
                          {dayjs(params.row.createdAt).format("hh:mmA")}
                        </div>
                      );
                    },
                  },
                  {
                    field: "lastSubscriptionDate",
                    width: 220,

                    headerName: "Last Subscription Date",
                    renderCell: (
                      params: GridRenderCellParams<UserSubscriptionProps>
                    ) => {
                      return (
                        <div>
                          {dayjs(params.row.lastSubscriptionDate).format(
                            "DD MMM YYYY"
                          )}
                          &nbsp;at&nbsp;
                          {dayjs(params.row.lastSubscriptionDate).format(
                            "hh:mmA"
                          )}
                        </div>
                      );
                    },
                  },
                  {
                    field: "transactionID",
                    minWidth: 300,

                    headerName: "Transaction ID",
                    renderCell: (
                      params: GridRenderCellParams<UserSubscriptionProps>
                    ) => {
                      return (
                        <div>
                          <CopyButton value={params.row.transactionID}>
                            {({ copied, copy }) => (
                              <Tooltip
                                label={copied ? "Copied!" : "Copy to clipboard"}
                              >
                                <span
                                  className="pointer"
                                  onClick={copy}
                                  style={{
                                    color: copied
                                      ? Colors.GreenPrimary
                                      : Colors.BluePrimary,
                                  }}
                                >
                                  {params.row.transactionID}
                                </span>
                              </Tooltip>
                            )}
                          </CopyButton>
                        </div>
                      );
                    },
                  },
                  {
                    field: "",
                    width: 140,
                    headerName: "Type",
                    renderCell: (
                      params: GridRenderCellParams<UserSubscriptionProps>
                    ) => {
                      return (
                        <div
                          style={{
                            color:
                              params.row.lastSubscriptionDate -
                                params.row.createdAt >
                              30 * 24 * 60 * 60
                                ? Colors.GreenPrimary
                                : Colors.BluePrimary,
                          }}
                        >
                          {params.row.lastSubscriptionDate -
                            params.row.createdAt >
                          30 * 24 * 60 * 60
                            ? "Renewal"
                            : "Initial"}
                        </div>
                      );
                    },
                  },

                  {
                    field: "expiresAt",
                    width: 140,
                    headerName: "Expiration Date",
                    renderCell: (
                      params: GridRenderCellParams<UserSubscriptionProps>
                    ) => {
                      return (
                        <div
                          style={{
                            color: dayjs(params.row.expiresAt).isBefore(dayjs())
                              ? Colors.RedPrimary
                              : Colors.GreenSecondary,
                          }}
                        >
                          {dayjs(params.row.expiresAt).format("DD MMM YYYY")}
                        </div>
                      );
                    },
                  },
                  {
                    field: "service",
                    width: 120,
                    headerName: "Service",
                    renderCell: (
                      params: GridRenderCellParams<UserSubscriptionProps>
                    ) => {
                      return (
                        <div className="flex-row align-center service-images">
                          <img
                            src={BrandImages.retrieveImage(params.row.service)}
                            alt=""
                            className="image"
                          />
                        </div>
                      );
                    },
                  },
                ]}
              />
              <div className="flex-row align-center justify-center width-100">
                <Pagination
                  value={pagination.page}
                  onChange={(value) => {
                    setPagination({ ...pagination, page: value });
                  }}
                  my={40}
                  disabled={
                    subscriptions?.data.length === 0 || isLoadingSubscriptions
                  }
                  total={getPaginationTotal(
                    subscriptions?.totalRecords,
                    pagination.limit
                  )}
                />
              </div>
            </>
          )}
          {isLoadingSubscriptions && <MegaLoader />}
        </div>
      </div>
    </Container>
  );
};

export default Subscriptions;
